import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import EventEndWithoutDefectsModal from './EventEndWithoutDefectsModal';

interface EventEndChoiceModalProps {
  show: boolean;
  onHide: () => void;
  eventName: string;
  onEndWithoutDefects: (completionNotes: string) => void;
  onEndWithDefects: () => void;
}

const EventEndChoiceModal: React.FC<EventEndChoiceModalProps> = ({
  show,
  onHide,
  eventName,
  onEndWithoutDefects,
  onEndWithDefects
}) => {
  const [showNotesModal, setShowNotesModal] = useState(false);

  const handleEndWithoutDefectsClick = () => {
    setShowNotesModal(true);
  };

  const handleConfirmNotes = (notes: string) => {
    setShowNotesModal(false);
    onEndWithoutDefects(notes);
  };

  return (
    <>
    <Modal show={show && !showNotesModal} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>סיום אירוע - {eventName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="info" className="mb-3">
          בחר איך ברצונך לסיים את האירוע:
        </Alert>
        
        <div className="d-grid gap-2">
          <Button 
            variant="success" 
            size="lg" 
            onClick={handleEndWithoutDefectsClick}
            className="mb-2"
          >
            ✅ סיים אירוע ללא תקלות
            <br />
            <small className="text-muted">הציוד יוחזר למלאי ללא דיווח תקלות</small>
          </Button>
          
          <Button 
            variant="warning" 
            size="lg" 
            onClick={onEndWithDefects}
          >
            ⚠️ סיים אירוע עם דיווח תקלות
            <br />
            <small className="text-muted">תוכל לדווח על ציוד תקול ולהגדיר פריוריטי</small>
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          ביטול
        </Button>
      </Modal.Footer>
    </Modal>
    {showNotesModal && (
      <EventEndWithoutDefectsModal
        show={showNotesModal}
        onHide={() => setShowNotesModal(false)}
        eventName={eventName}
        onConfirm={handleConfirmNotes}
      />
    )}
    </>
  );
};

export default EventEndChoiceModal;

